/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Preview_ApproximateInputs */



/**
* | output |
* | --- |
* | "The preview uses the oneAI design. Your template's branding, including its own fonts, is applied on download." |
*
* @param {Presentation_Template_Preview_ApproximateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_preview_approximate = /** @type {((inputs?: Presentation_Template_Preview_ApproximateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Preview_ApproximateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Vorschau nutzt das oneAI-Design. Das Branding Ihrer Vorlage – inklusive eigener Schriften – wird beim Download angewendet.")
	return /** @type {LocalizedString} */ ("The preview uses the oneAI design. Your template's branding, including its own fonts, is applied on download.")
});